"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePaymentLineForTip = exports.addPaymentLine = void 0;
const shared_1 = require("@getgreenline/shared");
const addPaymentLine = async ({ companyId, locationId, payload, }) => {
    const res = await shared_1.axios.post(`/api/v1/companies/${companyId}/locations/${locationId}/payment-lines`, payload);
    return res.data;
};
exports.addPaymentLine = addPaymentLine;
const updatePaymentLineForTip = async ({ companyId, locationId, paymentLineId, payload, }) => {
    const res = await shared_1.axios.put(`/api/v1/companies/${companyId}/locations/${locationId}/payment-lines/${paymentLineId}/add-tip-amount`, payload);
    return res.data;
};
exports.updatePaymentLineForTip = updatePaymentLineForTip;
//# sourceMappingURL=paymentLineAPI.js.map